<template>
  <div>
    <h3 v-if="showOuterLabel" class="mb-3">
      {{ label }}
    </h3>
    <v-row>
      <v-col>
        <v-select
          @change="handleSelect"
          :no-data-text="$t('appointment.filters.noData')"
          :loading="isLoading"
          :value="value"
          :label="label"
          :items="branches"
          item-text="name"
          item-value="id"
          return-object
          hide-details="auto"
          :dense="dense"
          outlined
          :prepend-inner-icon="prependInnerIcon"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import store from '@/store'
export default {
  name: 'AdminBranchSelect',

  props: {
    label: {
      type: String,
    },
    rules: {
      type: Array,
    },
    showOuterLabel: {
      type: Boolean,
      default: true,
    },
    dense: {
      default: true,
    },
    realEstateId: {
      default: null,
    },
    prependInnerIcon: {
      type: String,
      default: null,
    },
    value: Object,
  },

  data() {
    return {
      isLoading: true,
      uniqueBranch: null,
    }
  },

  methods: {
    ...mapActions(['fetchBranchesAsAdmin']),
    ...mapMutations(['setFilters']),

    handleSelect(value) {
      this.$emit('input', value)
    },
    fetchBranchesByRealEstate() {
      const realEstateFilterAlreadyApplied = store.getters.filters['realEstateId']
      var mappedParams = {
        realEstateId: this.realEstateId
      }
      Promise.resolve(
        this.setFilters({ ...store.getters.filters, ...mappedParams })
      ).then(() => {
        this.fetchBranchesAsAdmin()
        this.isLoading = false
      }).finally(() => {
        if (!realEstateFilterAlreadyApplied) {
          this.setFilters({ ...delete store.getters.filters.realEstateId })
        }
      })
    },
  },

  computed: {
    ...mapGetters(['branches'])
  },

  async mounted() {
    this.isLoading = true
    if (this.realEstateId) {
      this.fetchBranchesByRealEstate()
    } else {
      await this.fetchBranchesAsAdmin()
      this.isLoading = false
    }
  },
}
</script>
